<template>
  <div>
    <h4 class="main-header">{{ $t('navigation_gallery') }}</h4>
    <GalleryOverView :hiddenTags="hiddenTags" :isAllowedEdit="isAllowed('gallery_edit')" :isAllowedCSVDownload="isAvailable('gallery:csv_download')"/>
  </div>
</template>

<script>
import { GalleryOverView } from '@scantrust/st-gallery'
import '@scantrust/st-gallery/dist/index.css'
import { mapGetters } from 'vuex'

export default {
  name: 'Gallery',
  components: {
    GalleryOverView
  },
  computed: {
    ...mapGetters(['isAllowed', 'isAvailable']),

    hiddenTags () {
      return [
        'ulbs-editor-company-logo',
        'ulbs-editor-rpsb-consumption',
        'ulbs-editor-recyclability',
        'ulbs-editor-organic',
        'ulbs-editor-certifications',
        'ulbs-editor-product-image',
        'st-portal-brand-image'
      ]
    }
  }
}
</script>
